// FAQs for the website-development service page (also used for its FAQ JSON-LD).
const websiteFaqs = [
  {
    q: "How much does a custom website cost?",
    a: "It depends on the number of pages, features, integrations, and design complexity. Share your requirements and we will send a clear, itemised estimate.",
  },
  {
    q: "How long does it take to build a website?",
    a: "A business website usually takes 2–4 weeks. E-commerce stores and custom web applications typically take 6–12 weeks depending on scope and feedback.",
  },
  {
    q: "Will my website be mobile-friendly?",
    a: "Yes. Every website we build is fully responsive and tested on phones, tablets, and desktops.",
  },
  {
    q: "Will my website be SEO friendly?",
    a: "Yes. We follow SEO best practices: clean structure, fast loading, proper meta tags, schema markup, and mobile optimisation.",
  },
  {
    q: "Can you redesign my existing website?",
    a: "Absolutely. We can modernise the design, improve speed and SEO, and move your content to an easier-to-manage platform.",
  },
  {
    q: "Can I update the website content myself?",
    a: "Yes. We can build on a CMS or add an admin panel so your team can update text, images, products, and blogs without a developer.",
  },
  {
    q: "Do you provide support after launch?",
    a: "Yes. We offer maintenance plans covering updates, security, backups, performance monitoring, and small enhancements.",
  },
  {
    q: "How do I get started?",
    a: "Fill in the free consultation form below or contact us. We will schedule a short discovery call and share a proposal with timeline and cost.",
  },
];

export default websiteFaqs;
